import React from "react";
import { SourceItem } from "../../../../pages/ResourcePool/service";
import CourseWareViewer from "../../../CourseComponents/CourseWareViewer";

interface Props {
    data: SourceItem;
}
export default function Viewer({ data }: Props) {
    return <CourseWareViewer data={data} />;
}
